import agency from './agency';
import agencySetting from './agencySetting';
import settings from './settings';
import user from './user';
import vehicleSchedule from './vehicleSchedule';

export default {
  agency,
  agencySetting,
  settings,
  user,
  vehicleSchedule,
};



// WEBPACK FOOTER //
// ./src/common/reducers/index.js